"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M53.68,80.16a1.48,1.48,0,0,0,.26-.86,1.44,1.44,0,0,0-.59-1.2,2.54,2.54,0,0,0-1.59-.44H48.69V84h3.16A2.91,2.91,0,0,0,53,83.78a1.79,1.79,0,0,0,.79-.6,1.58,1.58,0,0,0,.27-.92,1.57,1.57,0,0,0-.3-1,1.54,1.54,0,0,0-.85-.57A1.56,1.56,0,0,0,53.68,80.16ZM50.3,78.91h1.18a1.26,1.26,0,0,1,.69.15.56.56,0,0,1,.21.49.49.49,0,0,1-.21.45,1.26,1.26,0,0,1-.69.15H50.3Zm2.05,3.68a1.18,1.18,0,0,1-.71.16H50.3V81.4h1.34a1.18,1.18,0,0,1,.71.16.58.58,0,0,1,.21.51A.6.6,0,0,1,52.35,82.59Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "39.19 84 39.19 79 41.09 79 41.09 77.66 35.62 77.66 35.62 79 37.51 79 37.51 84 39.19 84"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "65.5 78.93 65.5 77.66 60.99 77.66 60.99 84 65.5 84 65.5 82.72 62.6 82.72 62.6 81.41 65.32 81.41 65.32 80.14 62.6 80.14 62.6 78.93 65.5 78.93"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "55.4 77.66 55.4 84 59.75 84 59.75 82.66 57.05 82.66 57.05 77.66 55.4 77.66"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "7.88 77.66 6.17 77.66 9.05 84 10.37 84 13.26 77.66 11.58 77.66 9.73 81.94 7.88 77.66"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    x: "14.09",
    y: "77.66",
    width: "1.66",
    height: "6.34"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M42.85,82.69h2.81L46.23,84h1.63l-3-6.34H43.58l-3,6.34h1.66Zm1.4-3.28.88,2H43.38Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "21.85 78.93 21.85 77.66 17.34 77.66 17.34 84 21.85 84 21.85 82.72 18.96 82.72 18.96 81.41 21.67 81.41 21.67 80.14 18.96 80.14 18.96 78.93 21.85 78.93"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
    points: "28.33 77.66 27.19 77.66 25.77 81.68 24.45 77.66 22.77 77.66 25.03 84 26.35 84 27.71 80.19 29.05 84 30.37 84 32.63 77.66 31.07 77.66 29.69 81.75 28.33 77.66"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M71.67,7.17A7.18,7.18,0,0,0,64.5,0H7.17A7.18,7.18,0,0,0,0,7.17V63.06a7.18,7.18,0,0,0,7.17,7.17H64.5a7.18,7.18,0,0,0,7.17-7.17ZM48.31,2.5H64.5a4.67,4.67,0,0,1,4.67,4.67v8.45H48.31Zm-22.45,0h20V15.62h-20ZM2.5,7.17A4.67,4.67,0,0,1,7.17,2.5H23.36V15.62H2.5ZM7.17,67.73A4.67,4.67,0,0,1,2.5,63.06V18.12H23.36V67.73Zm18.69,0V18.12h20V67.73Zm38.64,0H48.31V18.12H69.17V63.06A4.67,4.67,0,0,1,64.5,67.73Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.07,30.09a1.25,1.25,0,0,0,0-2.5H7.5a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.07,39.5a1.25,1.25,0,0,0,0-2.5H7.5a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.07,48.82a1.25,1.25,0,0,0,0-2.5H7.5a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.07,58.17a1.25,1.25,0,1,0,0-2.5H7.5a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M41.12,30.09a1.25,1.25,0,0,0,0-2.5H30.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M41.12,39.46a1.25,1.25,0,0,0,0-2.5H30.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M41.12,48.82a1.25,1.25,0,0,0,0-2.5H30.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M41.12,58.17a1.25,1.25,0,0,0,0-2.5H30.55a1.25,1.25,0,1,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M64.12,30.09a1.25,1.25,0,0,0,0-2.5H53.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M64.12,39.5a1.25,1.25,0,0,0,0-2.5H53.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M64.12,48.82a1.25,1.25,0,0,0,0-2.5H53.55a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M64.12,58.17a1.25,1.25,0,0,0,0-2.5H53.55a1.25,1.25,0,0,0,0,2.5Z"
  })]
}), '0 0 71.67 84');